// extracted by mini-css-extract-plugin
export default {"sectionTitle_sub":"SectionTitle_sub_sectionTitle_sub__jFxxN"};